import { render, staticRenderFns } from "./PersonalAbilities.vue?vue&type=template&id=b02e1cbc"
import script from "./PersonalAbilities.vue?vue&type=script&lang=js"
export * from "./PersonalAbilities.vue?vue&type=script&lang=js"
import style0 from "./PersonalAbilities.vue?vue&type=style&index=0&id=b02e1cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
